import { z } from "zod";
import { NOTES_MAX } from "@shared/constants/validation.js";

const CARE_FIELD_MAX = NOTES_MAX;

const careField = z.string().trim().max(CARE_FIELD_MAX).nullable().optional();

/**
 * Upsert schema for care preferences. All fields are optional so partial
 * updates work, and null is valid to explicitly clear a field. No transforms
 * — omitted fields stay `undefined` and the service layer skips them.
 */
export const upsertCarePreferencesSchema = z.object({
  behavioralNotes: careField,
  calmingStrategies: careField,
  comfortItems: careField,
  communicationStyle: careField,
});

export type UpsertCarePreferencesInput = z.infer<typeof upsertCarePreferencesSchema>;
